import { Content } from "@/ui";
import SeoHead from "@/components/SeoHead";
import styles from "./styles.module.scss";
import { community_helper } from "@/helpers/community_helper";

export default function InclusivePage({ title, canonical, content }) {
  return (
    <div className={styles.cont}>
      <SeoHead title={title} canonical={canonical} />
      <Content items={content} />
    </div>
  );
}

export async function getStaticProps({}) {
  return {
    props: {
      title: "Empowering Sustainable Growth",
      canonical: "/empowering-sustainable-growth",
      content: [
        {
          component: "Hero",
          props: {
            title: {
              path: "esg.hero.title",
              placeholder: "Empowering Sustainable Growth",
            },
            background: {
              path: "esg.hero.background",
            },
            video: "https://cdn.sourceflow.co.uk/z9jbk3objc0mn1nf7en9275hvxdp",
          },
        },
        {
          component: "ContentSection",
          props: {
            title: {
              path: "esg.content.title",
              placeholder:
                "Our mission is to Empower Sustainable Growth. Empowering Sustainable Growth was developed around the concept of prioritising people and having a positive impact. ",
            },
            description: {
              path: "esg.content.body",
              placeholder:
                "Understanding our client and candidate's individual needs and motivations as well as developing personable relationships, that are consultative and not transactional, has always been a part of Insight's DNA. Empowering Sustainable Growth looks to place this notion at the heart of our activity and reminds us of the powerful effect we can have collectively. We have the desire to make a difference, to create long-term partnerships built upon trust, and deliver a quality service that consistently adds value. Our commitment goes beyond connecting professionals with opportunities; it extends to supporting and empowering the next generation of STEM enthusiasts. We firmly believe that by nurturing a robust community, we can contribute to the advancement of these fields. Moreover, we are passionate about giving back through our charity initiatives, recognising the importance of creating a positive impact beyond professional development. Join us in building a community where young professionals thrive, ideas flourish, and where our collective efforts create lasting change in both careers and communities alike.",
            },
            className: styles.contentSection,
          },
        },
        // {
        //   component: "VideoSection",
        //   props: {
        //     video: "https://www.youtube.com/embed/rrD1FNZV8tg?si=og6nLi4Q2Kra_6_u&amp;controls=0",
        //   }
        // },
        {
          component: "CommunitySection",
          props: {
            cards: community_helper.fetch(),
          },
        },
      ],
    },
  };
}
